<script lang="ts">
  import Fa from 'svelte-fa';
  import { faPlus } from '@fortawesome/free-solid-svg-icons';
  import type HpEditSubModal from './HpEditSubModal.svelte';
  import type HpAddModal from './HpAddModal.svelte';
  import type { System, VisibleDkcs } from './+page.svelte';

  let {
    activeOnly,
    editable,
    disabled,
    hpEditSubModal,
    hpAddModal,
    visibleDkcs,
    system,
  }: {
    activeOnly: boolean;
    editable: boolean;
    disabled: boolean;
    hpEditSubModal: HpEditSubModal;
    hpAddModal: HpAddModal;
    system: System;
    visibleDkcs: VisibleDkcs;
  } = $props();
</script>

<table class="table-zebra table">
  <thead>
    <tr>
      <th>DKC &gt; <span class="text-info">Controller</span> </th>
      <th>Channel Board</th>
      <th>Speed</th>
      <th>Description</th>
      {#if !activeOnly}
        <th>Active</th>
      {/if}
    </tr>
  </thead>
  <tbody class="text-xs!">
    {#if visibleDkcs.length === 0}
      <tr>
        <td colspan={4} class="text-center!">No DKCs</td>
      </tr>
    {/if}
    {#each visibleDkcs as dkc}
      <tr
        class={editable ? 'cursor-pointer' : ''}
        onclick={editable
          ? () =>
              hpEditSubModal.openModal(
                { type: 'dkc', item: { ...dkc, ids: [dkc.id] } },
                system.active,
              )
          : undefined}
      >
        <td class="text-lg font-bold">{dkc.name}</td>
        <td></td>
        <td></td>
        <td></td>

        {#if !activeOnly}
          <td class="text-center!">
            <input
              type="checkbox"
              class="checkbox checkbox-xs checkbox-primary"
              checked={dkc.active}
              readonly
              onclick={(e) => e.preventDefault()}
            />
          </td>
        {/if}
      </tr>
      {#each dkc.controllers.filter((c) => c.active || !activeOnly) as ctl}
        <tr
          class={editable ? 'cursor-pointer' : ''}
          onclick={editable
            ? () =>
                hpEditSubModal.openModal(
                  {
                    type: 'controller',
                    item: { ...ctl, ids: [ctl.id] },
                  },
                  dkc.active,
                )
            : undefined}
        >
          <td class="text-info font-bold">
            {ctl.name}
          </td>
          <td></td>
          <td></td>
          <td></td>

          {#if !activeOnly}
            <td class="text-center!">
              <input
                type="checkbox"
                class="checkbox checkbox-xs checkbox-primary"
                checked={ctl.active}
                readonly
                onclick={(e) => e.preventDefault()}
              />
            </td>
          {/if}
        </tr>
        {#each ctl.channelBoards.filter((c) => c.active || !activeOnly) as chb}
          <tr
            class="cursor-pointer"
            onclick={() =>
              // TODO:
              hpEditSubModal.openModal(
                {
                  type: 'channelBoard',
                  item: { ...chb, ids: [chb.id] },
                },
                ctl.active,
              )}
          >
            <td></td>
            <td class="text-accent text-left! font-bold">
              {chb.name}
            </td>
            <td class="text-center!">{chb.speed.toFixed(0)} Gb / s</td>
            <td>{chb.description ?? ''}</td>
            {#if !activeOnly}
              <td class="text-center!">
                <input
                  type="checkbox"
                  class="checkbox checkbox-xs checkbox-primary"
                  checked={chb.active}
                  readonly
                  onclick={(e) => e.preventDefault()}
                />
              </td>
            {/if}
          </tr>
        {/each}
        <tr class="bg-transparent!">
          <td></td>
          <td>
            <button
              class="btn btn-sm btn-soft btn-accent"
              onclick={(e) => {
                e.preventDefault();
                hpAddModal.openModal({
                  type: 'channelBoard',
                  siblings: ctl.channelBoards,
                  parent: ctl,
                });
              }}
              {disabled}
            >
              <Fa icon={faPlus} class="mr-2" />
              Add a channel board
            </button>
          </td>
          <td></td>
          <td></td>
        </tr>
      {/each}
      <tr class="bg-transparent!">
        <td>
          <button
            class="btn btn-sm btn-soft btn-info mb-4"
            onclick={(e) => {
              e.preventDefault();
              hpAddModal.openModal({
                type: 'controller',
                siblings: dkc.controllers,
                parent: dkc,
              });
            }}
            {disabled}
          >
            <Fa icon={faPlus} class="mr-2" />
            Add a controller
          </button>
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    {/each}
  </tbody>
</table>
<button
  class="btn btn-primary btn-soft my-8 w-full"
  {disabled}
  onclick={(e) => {
    e.preventDefault();
    hpAddModal.openModal({
      type: 'dkc',
      parent: system,
      siblings: system.hpDetails!.dkcs,
    });
  }}
>
  <Fa icon={faPlus} class="mr-2" />
  Add a DKC
</button>

<style>
  th,
  td {
    border-width: 0 1px 0 0;
    border-color: var(--color-table-border);
  }
</style>
